import emptyImg from '@/assets/images/management/price-list-empty.svg'
import {
  FeedbackBlock,
  FeedbackBlockDescription,
  FeedbackBlockGraphic,
  FeedbackBlockTitle,
} from '@/components/ui/feedback-block'

type FeedbackPriceListEmptyProps = {
  hasFilters: boolean
}

export const FeedbackPriceListEmpty = ({
  hasFilters,
}: FeedbackPriceListEmptyProps) => (
  <FeedbackBlock className="mx-auto max-sm:py-0">
    <FeedbackBlockGraphic>
      <img
        src={emptyImg}
        alt="Ilustração de duas pessoas interagindo com uma interface em um dispositivo móvel. À esquerda, uma pessoa sentada em uma cadeira segura um notebook, enquanto à direita, uma pessoa em pé toca na tela do dispositivo, que exibe imagens e opções interativas"
      />
    </FeedbackBlockGraphic>

    {hasFilters && (
      <FeedbackBlockTitle
        className="mb-0"
        title="NENHUM RESULTADO ENCONTRADO"
      />
    )}

    <FeedbackBlockDescription
      className="text-gray-400"
      description={
        hasFilters
          ? 'PARA MELHORES RESULTADOS EDITE A BUSCA OU LIMPE OS FILTROS.'
          : "NO MOMENTO NÃO HÁ LISTAS CADASTRADAS, CLIQUE EM 'NOVA LISTA' PARA ADICIONÁ-LAS."
      }
    />
  </FeedbackBlock>
)
